import React, { useContext } from 'react';
import { Box, VStack, Spinner } from '@chakra-ui/react';
import { SessionContext } from '../context/SessionContext';
import HeaderDashboard from '../components/HeaderDashboard';
import ContentDashboard from '../components/ContentDashboard';
import NavBarFooterDashboard from '../components/NavBarFooterDashboard';
import { useAuth } from '../context/AuthContext';
//import RequestUnlockButton from '../components/RequestUnlockButton';
//import StartSessionButton from '../components/StartSessionButton';

const Dashboard = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Box>
    );
  }
  return (
    <>
      <HeaderDashboard />
      <ContentDashboard />
      <Box position="fixed" bottom="0" width="100%" bg="white" zIndex="1000">
        <VStack spacing={0} align="stretch">
          <NavBarFooterDashboard />
        </VStack>
      </Box>
    </>
  );
};

export default Dashboard;